/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LeaveOrgResponseActiveRole } from './leaveOrgResponseActiveRole';
import type { OrganizationResponse } from './organizationResponse';

export interface LeaveOrgResponse {
  left_workos_org_id: string;
  active_org?: OrganizationResponse | null;
  active_role?: LeaveOrgResponseActiveRole;
}
